import React, { ReactNode } from 'react';

export interface IHideContainerProps extends React.AllHTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  hide?: boolean;
  remove?: boolean;
}

export const HideContainer = React.forwardRef<HTMLDivElement, IHideContainerProps>(
  ({ children, hide, remove, style, ...props }, ref) => {
    return (
      <div style={{ display: hide ? 'none' : 'flex', width: '100%', ...style }} ref={ref} {...props}>
        {remove ? null : children}
      </div>
    );
  },
);
